import { render } from "./AvatarDisplay.vue?vue&type=template&id=25bd9306&scoped=true"
import script from "./AvatarDisplay.vue?vue&type=script&lang=js"
export * from "./AvatarDisplay.vue?vue&type=script&lang=js"

import "./AvatarDisplay.vue?vue&type=style&index=0&id=25bd9306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bd9306"]])

export default __exports__